import wixSite from 'wix-site';
import {filterProducts,sortProducts,updateClicksOnObject} from 'public/productsListRepeater.js'; 
import {runProgressBar} from 'public/selectedPageHeader.js'; 
import wixData from 'wix-data';


$w.onReady(function () {
    runProgressBar($w('#pageProgressBar'),1500);  
    $w('#pageNameText').text = wixSite.currentPage.name;
});


// Product Sorting
export function sortByPriceUpButton_click(event) {
    sortProducts($w('#dataset1'),'ascending','price');
    runProgressBar($w('#pageProgressBar'),1500);  
  
    $w('#sortByPriceDownSelectedButton').hide();
    $w('#sortByPriceUpButton').hide();
    $w('#sortByPriceDownButton').show();
    $w('#sortByPriceUpSelectedButton').show();
}

export function sortByPriceDownButton_click(event) {
    sortProducts($w('#dataset1'),'descending','price');	  
    runProgressBar($w('#pageProgressBar'),1500);

    $w('#sortByPriceDownSelectedButton').show();
    $w('#sortByPriceUpButton').show();
    $w('#sortByPriceDownButton').hide();
    $w('#sortByPriceUpSelectedButton').hide();      
}

export function sortByPriceUpSelectedButton_click(event) {
    sortProducts($w('#dataset1'),'descending','price');	  
    runProgressBar($w('#pageProgressBar'),1500);
    
    $w('#sortByPriceDownSelectedButton').show();
    $w('#sortByPriceUpButton').show();
    $w('#sortByPriceDownButton').hide();
    $w('#sortByPriceUpSelectedButton').hide();
}

export function sortByPriceDownSelectedButton_click(event) {
    sortProducts($w('#dataset1'),'ascending','price');	  
    runProgressBar($w('#pageProgressBar'),1500);
    
    $w('#sortByPriceDownSelectedButton').hide();
    $w('#sortByPriceUpButton').hide();
    $w('#sortByPriceDownButton').show();
    $w('#sortByPriceUpSelectedButton').show();
}


// Click counter triggers.
export function spaProductImage_click(event) 
{
    updateClicksOnObject(event);   
}

export function whatsappButton_click(event) 
{
	updateClicksOnObject(event);   
}

export function priceButton_click(event)
{
	updateClicksOnObject(event);   
}


export function durationButton_click(event) 
{
	updateClicksOnObject(event);   
}
